import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Portal, Typography } from "@mui/material";

const styles = {
  alert: {
    width: "100%",
  },
  title: {
    fontSize: 16,
  },
  message: {
    fontSize: 14,
  },
};

type props = {
  show: boolean;
  onClose: any;
  title?: string;
  message?: string;
};

export default function ErrorNotification({
  show,
  onClose,
  title,
  message,
}: props) {
  return (
    <Portal>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={show}
        autoHideDuration={5000}
        onClose={onClose}
      >
        <Alert
          onClose={onClose}
          severity="error"
          variant="filled"
          sx={styles.alert}
        >
          <Typography sx={styles.title}>{title}</Typography>
          <Typography sx={styles.message}>{message}</Typography>
        </Alert>
      </Snackbar>
    </Portal>
  );
}
